import React from 'react';
import { connect } from 'react-redux';
import { fetchProjects, resetProjects, deleteProject, importProject, createProject, addDriverByGTIN, updateDriverProperties, updateDriverNamedProperties } from '../../../actions';
import { decode, encode } from 'base-64'
import moment from 'moment';

import drivers, {postDriverApiUrl} from '../../../apis/drivers';

if (!window.btoa) { window.btoa = encode }

if (!window.atob) { window.atob = decode }

class CreateProjectFromUrl extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {

        const searchParams = new URLSearchParams(this.props.location.search);
        const driverParams = []
        for (const [key, value] of searchParams.entries()) {
            var a = {"name": key, "value": value}
            driverParams.push(a);
        }

        const timeStamp = moment().unix();
        const temporaryProject = {
            name: 'urlProject_' + timeStamp,
            orderCode: '',
            customer: '',
            description: '',
        };

        const namedProperty = [{"name":"cur.0", "value":"151"}]

        // http://localhost:3000/#/createProjectlife?gtin=4062172174275&cur.0=155&d2d.en=1
        this.props.createProject(temporaryProject)
            .then(() => {
                drivers.post(postDriverApiUrl(this.props.project.id, searchParams.get('gtin'), 'latest', ''))
                    .then((driverId) => {

                        this.props.updateDriverNamedProperties(this.props.project.id, driverId.data, driverParams)
                            .then(() => {
                                this.props.history.push('/projects/' + this.props.project.id + '/driver', { state: this.state });
                                this.props.history.go('/projects/' + this.props.project.id + '/driver');
                            })
                    })
            })
            .catch((err) => {
                console.error(err)
            });
    }

    render() {

        return (
            <div className="container-project-cloud-list">
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        projects: state.projects != null ? Object.values(state.projects) : null,
        project: state.project.info
    };
};

const mapDispatchToProps = {
    fetchProjects,
    resetProjects,
    deleteProject,
    importProject,
    createProject,
    addDriverByGTIN,
    updateDriverProperties,
    updateDriverNamedProperties
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateProjectFromUrl);
